import { BillingCode } from "../../../components/Billing/billingCodes";
import { isInvalidLoginMessage, isUnconfirmedEmailMessage } from "../legacyBillingMessages";

// Why /Account/login refused, read off the envelope it refused with.

/**
 * The code a wrong email or password is answered with. A sign in code rather
 * than a billing one, so it is not in BillingCode, which lists the billing
 * API's.
 */
export const INVALID_CREDENTIALS = "INVALID_CREDENTIALS";

// The envelope, in whichever shape the refusal arrived. An HTTP error carries
// it on its response. An axios error without one never got an answer, and its
// own `code` and `message` (ECONNABORTED for a timeout) are axios's, not the
// server's. Anything else is the envelope itself: a refusal on a 200, which
// httpService hands over as it came.
const readEnvelope = (error) => {
   if (error?.response) return error.response.data;
   return error?.isAxiosError ? null : error;
};

/** The machine code the server refused with, or null when it sent none. */
export const readFailureCode = (error) => readEnvelope(error)?.code ?? null;

/**
 * The email or the password is wrong. Told by the code. A backend that has not
 * been redeployed with it says so only in a sentence, in `errors` with
 * `message` empty, so the sentence is read too — but only when no code came
 * with it, since a code is the server's word and a different one is a
 * different failure.
 */
export const isInvalidCredentials = (error) => {
   const code = readFailureCode(error);
   if (code) return code === INVALID_CREDENTIALS;

   const envelope = readEnvelope(error);
   return isInvalidLoginMessage(envelope?.errors?.[0]) || isInvalidLoginMessage(envelope?.message);
};

/**
 * The password is right but the email was never confirmed, so the code mailed
 * at sign up is asked for. Told by the code EMAIL_NOT_CONFIRMED, on a 403 with
 * the account in `data.user`. A backend from before the code answers with a
 * 200 refusal and only the sentence, in `errors`, which is read when no code
 * came with it.
 */
export const isEmailNotConfirmed = (error) => {
   const code = readFailureCode(error);
   if (code) return code === BillingCode.EMAIL_NOT_CONFIRMED;

   const envelope = readEnvelope(error);
   return (
      isUnconfirmedEmailMessage(envelope?.errors?.[0]) || isUnconfirmedEmailMessage(envelope?.message)
   );
};
